// @flow
import React from 'react';

import type { ShareOptionsType } from '@site-builder/common/src/types/model/landing';

import './style.pcss';

type Props = {
  isServerSideRender: boolean,
  shareOptions: ShareOptionsType,
  locale: string
};

const ShareOptions = ({
  isServerSideRender, shareOptions, locale
}: Props) => (
  !isServerSideRender
    ? (
      <div className='sharing-options'>
        {shareOptions.facebookLike && <div className='sharing-options__item sharing-options__item--fb-like-fake' />}
        {shareOptions.facebookShare && <div className='sharing-options__item  sharing-options__item--fb-share-fake' />}
        {shareOptions.tweet && <div className='sharing-options__item sharing-options__item--twitter-fake' />}
      </div>
    )
    : (
      <div className='sharing-options'>
        {shareOptions.facebookLike && (
          <div
            className='fb-like'
            data-layout='button_count'
            data-action='like'
            data-size='large'
            data-show-faces='true'
            data-share='false'
          />
        )}
        {shareOptions.facebookShare && (
          <div
            // TODO привести классы к БЕМ
            className='fb-share-button'
            data-layout='button'
            data-size='large'
          />
        )}
        {shareOptions.tweet && (
          <a
            // TODO привести классы к БЕМ
            className='twitter-share-button'
            href='https://twitter.com/intent/tweet'
            data-size='large'
            data-lang={locale}
          />
        )}
      </div>
    )
);

export default ShareOptions;
